import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { Button } from 'components/Form/Button/Button';

const DEFAULT_LIMIT = 5;

type BadgeListProps = {
  values: Array<string>;
  emptyLabel: string;
  color?: BadgeColor;
  limit?: number;
  sort?: boolean;
};

export const BadgeList = ({ values, emptyLabel, color, limit = DEFAULT_LIMIT, sort = true }: BadgeListProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  if (values.length === 0) {
    return <span className="text-sm text-gray-400">{emptyLabel}</span>;
  }

  const ordered = sort ? Array.from(values).sort((a, b) => a.localeCompare(b)) : values;
  const shouldTruncate = !isExpanded && ordered.length > limit;
  const visible = shouldTruncate ? ordered.slice(0, limit) : ordered;
  const remainingCount = ordered.length - limit;

  return (
    <div className="flex flex-wrap gap-2">
      {visible.map((value) => (
        <Badge key={value} color={color}>
          {value}
        </Badge>
      ))}
      {shouldTruncate && (
        <Button
          analyticsId="badge-list:show-more"
          variant="minimal"
          onClick={() => setIsExpanded(true)}
          className="rounded-full! border bg-gray-50 px-2! py-0.5! text-xs"
        >
          {t('common:emailBadgeList.showMore', { count: remainingCount })}
        </Button>
      )}
    </div>
  );
};
